import { useMemo } from "react";

import { isFalsy } from "@vega-core/utils/isFalsy";

import { groupPermissionsBySubject } from "../../../helpers/groupPermissions";

export const useRoleTabsData = (permissions: UserPermissionEntry[]) =>
  useMemo(() => {
    const manageablePermissions = permissions.filter((item) => item.manageable);

    const groupedBySubject = groupPermissionsBySubject(manageablePermissions);

    return groupedBySubject.reduce<
      Partial<Record<SubjectType, typeof groupedBySubject>>
    >(
      (acc, item) => {
        const { subjectType } = item;

        if (isFalsy(subjectType)) {
          console.warn("No subjectType found", item);

          return acc;
        }

        if (isFalsy(acc[subjectType])) {
          acc[subjectType] = [];
        }

        acc[subjectType].push(item);

        return acc;
      },
      {} as Partial<Record<SubjectType, typeof groupedBySubject>>,
    );
  }, [permissions]);

import { type SubjectType } from "@vega-api/generated/types/subjectType";
import { type UserPermissionEntry } from "@vega-api/generated/types/userPermissionEntry";
